"use client";

import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { debounce } from "lodash";
import { useCallback } from "react";
import { useStoreEmailFilterActions } from "../filter/hooks/actions";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;
  const { updateFilter } = useStoreEmailFilterActions();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFilter({ key: "search", value: event.target.value });
  };

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    []
  );

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filtrar Loja..."
          onChange={debouncedHandleInputChange}
          className="h-8 w-[150px] lg:w-[250px]"
        />
        {/* {table.getColumn("status") && (
          <DataTableFacetedFilter
            column={table.getColumn("status")}
            title="Grupo"
            options={statuses}
          />
        )} */}
        {/* {table.getColumn("priority") && (
          <DataTableFacetedFilter
            column={table.getColumn("priority")}
            title="Priority"
          />
        )} */}
        {isFiltered && (
          <Button
            variant="ghost_disabled"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Resetar
            <X />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
      {/* <Button onClick={handleOpenModal} className="mx-2">
        Adicionar Email de Loja
      </Button> */}
    </div>
  );
}
